import styled, { css } from 'styled-components'
import { CustomTheme } from 'themes/types'

import { makeStyles } from '@mui/styles'

import { IMAGES_PATH } from 'themes'

const visibilityOn = IMAGES_PATH('/visibility-on.svg')
const visibilityOff = IMAGES_PATH('/visibility-off.svg')
const blueArrowTop = IMAGES_PATH('/blueArrowUp.svg')
const blueArrowDown = IMAGES_PATH('/blueArrowDown.svg')

export const useDropDownStyles = makeStyles((theme: CustomTheme) => ({
    splitter: {
        display: 'flex',
        alignItems: 'center',
        gap: 20,
        fontWeight: 600,
        textAlign: 'left',
        whiteSpace: 'nowrap',
        position: 'relative',
        margin: '30px 0 10px 0',
        color: '#222222',
        fontSize: 16,
        lineHeight: '20px',
        [theme.breakpoints.down('sm')]: {
            gap: 10,
            '& .drop-down-title': {
                whiteSpace: 'normal',
            },
        },
    },
    splitterLarger: {
        margin: '60px 0 0 0',
    },
    noMargin: {
        margin: 0,
    },
    collapsedDropDown: {
        border: '1px solid #DDDDDD',
        padding: '12px',
    },
    splitterLine: {
        height: 1,
        width: '100%',
        backgroundColor: '#DDDDDD',
        [theme.breakpoints.down('sm')]: {
            minWidth: 30,
            width: 'auto',
            flex: 1,
        },
    },
    visabilityTurningButton: {
        backgroundColor: '#F4F6F9',
        borderRadius: 19,
        width: 38,
        height: 38,
    },
    dropDownOptions: {
        position: 'absolute',
        right: 22,
        padding: '0 5px',
        margin: '0 8px',
    },
}))

export const ChangeVisabilityButton = styled.div<{
    type?: string
    isVisible?: boolean
    bgColor?: string
    size?: number
    onClick: () => void
}>`
    ${props =>
        props.type === 'eye' &&
        css`
            background-image: url(${props.isVisible ? visibilityOff : visibilityOn});
            background-color: ${props.bgColor || '#F4F6F9'};
        `}
    ${props =>
        props.type === 'arrow' &&
        css`
            background-image: url(${props.isVisible ? blueArrowTop : blueArrowDown});
            background-color: ${props.bgColor || '#E9F8FF'};
        `}


    background-repeat: no-repeat;
    background-size: 15px 14px;
    background-position: center;
    border-radius: 50%;
    width: ${({ size }) => `${size || 38}px`};
    height: ${({ size }) => `${size || 38}px`};
    cursor: pointer;
`

export const DrowDownOptions = styled.div<{ type?: 'eye' | 'arrow' | 'button' }>`
    ${props =>
        props.type === 'eye' &&
        css`
            position: absolute;
            right: 22px;
            padding: 0 5px;
        `}

    ${props =>
        props.type === 'arrow' &&
        css`
            order: -1;
        `}
`

export const DropDownOptionsContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
`

export const DropDownTitle = styled.div<{ larger: boolean }>`
    font-size: ${({ larger }) => (larger ? '20px' : '16px')};
`
